<template>
    <ExternalQueryList
        endpoint="/api/v2/competitions"
        :headlines="headlines"
        :filters="filters"
        :can-destroy="() => true"
        :can-update="() => true"
        reorder-endpoint="/api/v2/competitions/priorities"
        :get-reorder-payload="data => ({competitions: data})"
        @show="competition => $router.push(getUrl(competition))"
    >
        <template v-slot:default="{ row: competition }">
          <td>
            <router-link :to="getUrl(competition)">
              {{ competition.attributes.name }}
            </router-link>
          </td>

          <td>
            <span v-if="competition.attributes.is_active" class="label label-success">
              Active
            </span>

            <span v-else class="label label-warning">
              Inactive
            </span>
          </td>
        </template>
    </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
    components: {ExternalQueryList},

    computed: {
        headlines() {
            return [
              {width: 11, text: 'Name'},
              {width: 11, text: 'Status'}
            ]
        },

        filters() {
            return [
                [
                    {
                        width: 20,
                        widget: 'text',
                        name: 'search',
                        placeholder: 'Search...'
                    },
                    {
                        width: 4,
                        widget: 'submit'
                    }
                ]
            ]
        }
    },

    methods: {
        getUrl(competition) {
            return '/competitions/' + competition.id + '/edit'
        }
    }
}
</script>
